export default function NoUnreadNotificationsIcon({
  width = 40,
  height = 40,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='20' cy='20' r='20' fill='#1283DA' fillOpacity='0.1' />
      <path
        d='M19.4668 16.2689C19.4668 17.4 19.9161 18.4848 20.716 19.2847C21.5158 20.0845 22.6007 20.5339 23.7318 20.5339C24.863 20.5339 25.9478 20.0845 26.7476 19.2847C27.5475 18.4848 27.9968 17.4 27.9968 16.2689C27.9968 15.1377 27.5475 14.0529 26.7476 13.253C25.9478 12.4532 24.863 12.0038 23.7318 12.0038C22.6007 12.0038 21.5158 12.4532 20.716 13.253C19.9161 14.0529 19.4668 15.1377 19.4668 16.2689Z'
        stroke='#11AF22'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.8696 16.6243L22.9359 17.6905L25.6015 15.0249'
        stroke='#11AF22'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.009 23.1284C24.1654 23.7296 24.433 24.2962 24.798 24.7989H12.0029C12.0029 24.7989 13.0692 23.1427 13.0692 18.9345C13.0681 17.736 13.4708 16.5721 14.2124 15.6307C14.9539 14.6892 15.9911 14.025 17.1565 13.7454'
        stroke='#1283DA'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.979 26.9314C17.0673 27.2404 17.2538 27.5122 17.5103 27.7057C17.7668 27.8992 18.0794 28.0039 18.4007 28.0039C18.722 28.0039 19.0346 27.8992 19.2911 27.7057C19.5476 27.5122 19.7341 27.2404 19.8224 26.9314'
        stroke='#1283DA'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
